const NEXT_PATH = /^\/marketplace\/[a-z0-9-]{1,32}\/(connect|connected|disconnected)$/;

export default function safeNextPath(next) {
	return (typeof next === 'string' && NEXT_PATH.test(next)) ? next : '';
}
